<!--
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-03 13:17:34
 -->
<template>
  <div class="total" @touchmove.prevent>
    <course-video
      :img_video="true"
      :detail-obj="detailObj"
      :categories-arr="categoriesArr"
    ></course-video>
    <div class="hasPadding">
      <h5 class="title">{{ detailObj.courseName }}</h5>
      <course-docter-info
        :lec-list="detailObj.lecturerList"
      ></course-docter-info>
    </div>
    <div class="course_footer" v-if="status != 'before'">
      <p>想要向讲师直接提问？</p>
      <p>快来医生汇App</p>
      <div class="load" @click="toApp">下载</div>
    </div>
    <div class="course_footer" v-else-if="status == 'before'">
      <p class="startTime">开始时间：{{ detailObj.liveStartTime | time2 }}</p>
      <p @click="goRegi" class="signUp">立即报名</p>
    </div>
    <fan></fan>
  </div>
</template>
<script>
import CourseVideo from './components/CourseVideo.vue'; //与录播不一样
import CourseDocterInfo from '@/components/Course/CourseDocterInfo.vue';
import fan from '@/components/fan.vue';
import { live, shareCallback } from '@/api/ajax.js';
// TODO: vux
import { dateFormat } from 'vux';
import { mapState } from 'vuex';
export default {
  name: '',
  data() {
    return {
      detailObj: {},
      categoriesArr: [],
      isCollection: false,
      isSignIn: false,
      isSignUp: false,
      catalogObj: [],
      channelObj: {},
      status: '',
      showSignCover: false,
      startTime: '',
      loopLiveInter: null,
      shareFlag: true
    };
  },
  methods: {
    goRegi() {
      this.$router.push({ name: 'register' });
    },
    toApp() {
      window.location = 'http://cdn.yxvzb.com/WEB/static-html/downloadApp.html';
    },
    showCover() {
      this.showSignCover = true;
    },
    hideCover() {
      this.hideCover = false;
    },
    eventCollection(val) {
      this.isCollection = val;
    },

    detailTime() {
      if (
        new Date().getTime() <
        this.detailObj.liveStartTime - 10 * 60 * 1000
      ) {
        this.status = 'before';
      } else if (
        new Date().getTime() + 10 * 60 * 1000 >= this.detailObj.liveStartTime &&
        new Date().getTime() < this.detailObj.liveEndTime
      ) {
        this.status = 'living';
      } else {
        this.status = 'after';
      }
      this.startTime = dateFormat(
        this.detailObj.liveStartTime,
        'YYYY-MM-DD HH:mm:ss'
      );
    },
    getDetail() {
      let data = {
        id: this.$route.params.id
      };
      live.wxdetail(data).then(res => {
        //详情
        let course_from = this.$route.query.shequn ? 'shequn' : 'share';
        this.categoriesArr = this.$api.categoriesFilter(
          res.data.data.categories
        );
        this.detailObj = res.data.data;
        this.channelObj = this.detailObj.relationChannel;
        this.isCollection = this.detailObj.isCollection;
        this.isSignIn = this.detailObj.isSignIn;
        this.isSignUp = this.detailObj.isSignUp;
        let wxUserInfoObj = this.$api.getStorage('wxUserInfo') || {};

        let customSA = {};
        if (
          this.$route.query.sourceFrom == 'yabao' &&
          this.$route.query.source_user_id
        ) {
          // 如果是亚宝分享出来的 增加分享着ID
          customSA.source_user_id = this.$route.query.source_user_id;
        }
        let SADATA = {
          ...{
            pageUrl: location.href,
            course_id: this.$route.params.id,
            course_name: this.detailObj.courseName,
            course_type: 'live',
            from: course_from,
            web_edition: 2
          },
          ...customSA
        };
        sa.track('course_detail', SADATA, function() {});

        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.status != '0') {
              //恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '恭喜您获得3积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              //您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }
            sa.track(
              'share_total',
              {
                from: 'wx',
                type: 'live',
                target: this.$route.params.id,
                client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId || '',
                web_edition: 2
              },
              function() {}
            );

            // 分享埋点
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: 5, // 互动主体 直播，录播，资讯，病例，站内信，论坛
              contentid: this.$route.params.id, // 内容id
              first_cate: '', //一级分类
              second_cate: '', // 2级分类
              first_cate_id: '', // 1级分类id
              second_cate_id: '', //2级分类id
              author: this.detailObj.editor || '', //讲师/作者
              contentname: this.detailObj.courseName,
              source_user_id: this.$route.query.source_user_id || '' // 邀请人ID
              // location:'', //位置 站内，专区内，超级面对面内
            });
          });
        };
        this.$wxShareInfo(
          this.detailObj.courseName,
          this.detailObj.courseName,
          this.detailObj.coverPic,
          location.href,
          '',
          shareCallBackFunc
        );
        /*
         * socket
         * */
        this.detailTime();
        this.loopLiveInter = setInterval(() => {
          // 检测直播是否开始
          this.detailTime();
        }, 30 * 1000);
      });
    }
  },
  computed: {},
  components: {
    CourseVideo,
    CourseDocterInfo,
    fan
  },
  filters: {
    time: function(val) {
      return dateFormat(val, 'YYYY-MM-DD HH:mm:ss');
    },
    time2: function(val) {
      return dateFormat(val, 'YYYY-MM-DD HH:mm');
    }
  },
  watch: {},
  created() {
    sessionStorage.vueRouterBackPage = location.href;
    this.getDetail();
  },
  beforeDestroy() {
    clearInterval(this.loopLiveInter);
  }
};
</script>
<style lang="less" scoped>
.total {
  height: 100%;
  overflow: hidden;
}
.title {
  font-size: 0.4266rem;
  margin-top: 0.4rem;
}
.course_footer {
  -webkit-box-sizing: border-box;
  position: relative;
  margin-top: 0.42rem;
  text-align: center;
  font-size: 0.4533rem;
  font-weight: bold;
  padding: 0 0.4rem;
  width: 100%;
  height: 2.9333rem;
  padding-bottom: 8rem;
  p {
    margin-bottom: 0.1333rem;
    width: 100%;
  }
  .load {
    width: 2.107rem;
    height: 0.907rem;
    line-height: 0.907rem;
    margin: 0.4rem auto;
    font-size: 0.4rem;
    color: #027cfa;
    font-weight: normal;
    border: 1px solid #027cfa;
    text-align: center;
    border-radius: 3px;
  }
  .signUp {
    width: 92%;
    height: 1.1733rem;
    background: #027cfa;
    border-radius: 0.08rem;
    color: #fff;
    font-size: 0.4rem;
    text-align: center;
    line-height: 1.1733rem;
    position: absolute;
    bottom: 0;
  }
  .startTime {
    font-weight: normal;
  }
}
</style>
